import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: [],
  error: null
});

function rawDataForUrlReducer(state = initialState, action) {
  console.log(action.type)
  switch (action.type) {
    case ActionNames.REQUEST_SYNTHETIC_RAW_DATA:
      return state.merge({ data: [], loading: true });
    case ActionNames.RECEIVE_SYNTHETIC_RAW_DATA:
      return state.merge({ data: action.data, loading: false });
    case ActionNames.FAILURE_SYNTHETIC_RAW_DATA:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default rawDataForUrlReducer;
